import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  showEditForm(event) {
    // Don't trigger if clicking on the delete button
    if (event.target.closest('form')) return
    
    const companyId = event.currentTarget.dataset.companyId
    if (!companyId) return
    
    // Hide display, show edit form
    const displayEl = document.getElementById(`company-display-${companyId}`)
    const editEl = document.getElementById(`company-edit-${companyId}`)
    
    if (displayEl && editEl) {
      displayEl.classList.add('hidden')
      editEl.classList.remove('hidden')
    }
  }

  hideEditForm(event) {
    const companyId = event.currentTarget.dataset.companyId
    if (!companyId) return
    
    // Show display, hide edit form
    const displayEl = document.getElementById(`company-display-${companyId}`)
    const editEl = document.getElementById(`company-edit-${companyId}`)
    
    if (displayEl && editEl) {
      displayEl.classList.remove('hidden')
      editEl.classList.add('hidden')
    }
  }
}

